import { HubspotBrochureDownload } from ".";
import Lazyload from "react-lazy-load";
import MenubarAd1 from "../MenubarAd1";
import "../../styles/demo-req-page.css";
import VideoCarousel from "./VideoCarousel";
import { Trans, useTranslation, language } from "gatsby-plugin-react-i18next";


const GEmployeeWellnessPlatform = () => {

    return (
        <>
            <MenubarAd1
                home={"#home"}
                challenges={"#challenges"}
                programs={"#programs"}
                casestudy={"#casestudy"}
                bookDemo={"#bookDemo"}
            />
            <section id="home" name="home" className="homepage hero-bg gewpbg position-relative section-pdn-hero">
              <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block heroimg mb-5">
                <div className="col-12 col-md-7">
                  <div className="col-12">
                    <div className="text-white d-flex align-items-baseline justify-content-center justify-content-lg-start">
                        <svg className="mr-2" width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.1047 7.37815L21.4502 7.14015C21.3609 7.1104 21.2717 7.02115 21.2419 6.93189C21.0932 6.39638 20.9147 5.86087 20.7362 5.35511C20.6469 5.08736 20.4387 4.8791 20.1709 4.7601C19.9627 4.67085 19.7247 4.5816 19.5164 4.49234C19.0999 4.31384 18.8321 3.92708 18.8321 3.48082V1.10077C18.8321 0.50576 18.3264 0 17.7314 0C17.2256 0 16.7794 0.357007 16.6603 0.862768L16.3331 2.38005C16.2141 2.94531 15.6488 3.33207 15.0836 3.21307C13.001 2.88581 10.8887 2.85606 8.74668 3.21307C8.18142 3.30232 7.61616 2.94531 7.49716 2.38005L7.14015 0.862768C7.02115 0.357007 6.57489 0 6.06913 0C5.47411 0 4.96835 0.50576 4.96835 1.10077V3.48082C4.96835 3.92708 4.7006 4.34359 4.28409 4.49234C4.07584 4.5816 3.83783 4.67085 3.62958 4.7601C3.36182 4.8791 3.18332 5.08736 3.06431 5.35511C2.85606 5.86087 2.70731 6.39638 2.55855 6.93189C2.5288 7.02115 2.43955 7.1104 2.3503 7.14015L1.69579 7.3484C0.773516 7.64591 0 8.71693 0 9.6987V12.0788C0 13.0605 0.773516 14.1315 1.69579 14.4291L1.93379 14.5183C2.26105 14.6373 2.5288 14.9051 2.64781 15.2323C2.76681 15.6191 2.88581 16.0356 3.06431 16.4223C3.15357 16.6901 3.36182 16.8984 3.62958 17.0174C9.16319 19.4867 15.0538 19.3379 20.2007 17.0174C20.4684 16.8984 20.6469 16.6901 20.7659 16.4223C20.9147 16.0356 21.0634 15.6191 21.1824 15.2323C21.2717 14.8753 21.5395 14.6076 21.8965 14.5183L22.1642 14.4291C23.0865 14.1315 23.86 13.0605 23.86 12.0788V9.6987C23.8005 8.74668 23.027 7.67566 22.1047 7.37815ZM19.1892 14.9051C19.0999 15.2026 18.8619 15.4406 18.5644 15.5596C16.4223 16.4223 14.1613 16.8389 11.9002 16.8389C9.6392 16.8389 7.37815 16.3926 5.23611 15.5596C4.9386 15.4406 4.7006 15.2026 4.61135 14.9051C3.74858 12.287 3.74858 9.5202 4.61135 6.90214C4.7006 6.60464 4.9386 6.36663 5.23611 6.24763C7.40791 5.38486 9.6392 4.96835 11.9002 4.96835C14.191 4.96835 16.4223 5.41461 18.5644 6.24763C18.8619 6.36663 19.0999 6.60464 19.1892 6.90214C20.0519 9.5202 20.0519 12.287 19.1892 14.9051Z" fill="white"/>
                            <path d="M6.93164 8.68728V11.1566C6.93164 11.6921 7.3779 12.1383 7.91341 12.1383C8.44892 12.1383 8.89518 11.6921 8.89518 11.1566V8.68728C8.89518 8.15177 8.44892 7.70551 7.91341 7.70551C7.3779 7.67576 6.93164 8.12202 6.93164 8.68728Z" fill="white"/>
                            <path d="M14.875 8.68728V11.1566C14.875 11.6921 15.3213 12.1383 15.8568 12.1383C16.3923 12.1383 16.8385 11.6921 16.8385 11.1566V8.68728C16.8385 8.15177 16.3923 7.70551 15.8568 7.70551C15.3213 7.67576 14.875 8.12202 14.875 8.68728Z" fill="white"/>
                            <path d="M10.2052 13.3877H13.6265C13.7753 13.3877 13.8943 13.5067 13.8943 13.6555V14.5777C13.8943 14.7265 13.7753 14.8455 13.6265 14.8455H10.2052C10.0564 14.8455 9.93742 14.7265 9.93742 14.5777V13.6555C9.90767 13.5067 10.0564 13.3877 10.2052 13.3877Z" fill="white"/>
                            </svg>

                      <span className="font-weight-normal" style={{'fontSize' : '16px'}}>AI Powered</span>
                    </div>
                    <h1 className="font-weight-semibold hero-heading pt-0 no-br">
                      <Trans>
                      Global Employee <br />
                      Wellness Platform
                      </Trans>
                    </h1>
                    <p className="hero-para font-weight-semibold no-br" style={{ marginBottom: '20px' }}>
                      <Trans>
                      Drive engagement, reduce burnout, and boost productivity—trusted by companies worldwide.
                      </Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-md-flex justify-content-md-center d-lg-flex justify-content-lg-start align-items-center">
                      <a
                        href="#bookDemo" className="vfitcompanycta mr-3 arrowbtn-img"
                      >
                       Book a Demo
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-5 ">
                  <div className="right-img" style={{ maxWidth: "800px", margin: "0 auto" }}>
                    {/* <picture>
                      <source
                        media="(max-width: 768px)"
                        srcSet=
                          'https://res.cloudinary.com/vantagecircle/image/upload/v1742812884/VantageFit/2025/gewp-responsive_device.png'
                      />
                      <source
                        srcSet=
                          'https://res.cloudinary.com/vantagecircle/image/upload/v1742812884/VantageFit/2025/gewp-responsive_device.png'
                      />
                      <img
                        className="img-responsive"
                        src=
                          'https://res.cloudinary.com/vantagecircle/image/upload/v1742812884/VantageFit/2025/gewp-responsive_device.png'
                        alt="image 1"
                      />
                    </picture> */}
                    <video width="100%" height="auto" autoPlay muted playsInline>
                        <source src="/videos/employee-wellness-video.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              </div>
                <div id="challenges" className="container custom_container d-flex m-d-block justify-content-start align-items-center mb-5 gewpsection pt-5">
                <div className="col-12 col-md-7 col-lg-4 sync-fast">
                    <div className="col-12 sync-fast">
                        <p className="section-para font-weight-normal mb-0">For Modern Workforce</p>
                        <h2 className="py-2 section-heading green-text no-br text-white">
                            Personalized <br/>Wellness Challenges <br/>for your Team
                        </h2>
                      </div>
                    </div>
                    <div className="col-12 col-md-8">
                        <div className="row wellness-card justify-content-end">
                            <div className="wcard wcard1">
                                <div className="wc-text no-br">Step <br/>Challenges</div>
                                <p className="description">Range of engaging and fun step challenges to keep your team active.</p>
                            </div>
                            <div className="wcard wcard2">
                                <div className="wc-text no-br">Team <br/>Challenges</div>
                                <p className="description">Team based wellness activities that boosts team collaboration and engagement.</p>
                            </div>
                            <div className="wcard wcard3">
                                <div className="wc-text no-br">Custom <br/>Challenges</div>
                                <p className="description">Bespoke initiatives that align with your company’s values and goals.</p>
                            </div>
                            <div className="wcard wcard4">
                                <div className="wc-text no-br">Journey <br/>Challenges</div>
                                <p className="description">A fun wellness program where users embark on a virtual global adventure, earning rewards and badges with each milestone.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="bookDemo" name="bookDemo" className="w-100 demo-page-bg pt-3 px-2">
                <div className="pt-5 text-center">
                    <h2 className="font-weight-normal py-2 section-heading text-white">
                        Schedule a Vantage Fit Demo
                    </h2>
                    <p
                        className="section-para font-weight-normal text-white"
                    >
                        Explore a new era of team health with
                        our corporate wellness platform,
                        tailored to enhance employee well-being!
                    </p>
                </div>
                <div className="row container lndngpg">
                    <div className="col-md-6 col-sm-12">
                        <div className="padding-dem" style={{ padding : "3rem 0 3rem calc(100% - 43vw)" }}>
                            <div className="demo-pageform">
                                <Lazyload>
                                    <HubspotBrochureDownload formID="e23ab1ed-02c7-42c1-90bc-ecd78ae786c3" />
                                </Lazyload>
                            </div>
                        </div>
                    </div>
                    <div
                        id="video"
                        className="col-md-6 col-sm-12 dm-align-center padd-y-5"
                    >
                        <div className="container">
                            <div
                                className="w-100 d-flex justify-content-center"
                                style={{ height: "fit-content" }}
                            >
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    width="100%"
                                    height="auto"
                                    style={{
                                        borderRadius: "10px",
                                        maxWidth: "600px",
                                        border: "2px white solid",
                                    }}
                                >
                                    <source
                                        type="video/webm"
                                        src="https://res.cloudinary.com/vantagecircle/video/upload/v1704800863/VantageFit/2023/Vfit_Feature_1_copy.webm"
                                    />
                                    <source type="video/mp4" src="https://res.cloudinary.com/vantagecircle/video/upload/v1704800863/VantageFit/2023/Vfit_Feature_1_copy.mp4"></source>
                                    "Your browser does not support the video tag."
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section
                id="programs"
                name="programs"
                className="position-relative pt-5 dark-bg-gewp"
            >
                <div className="container custom_container py-5">
                    <h2 className="section-heading text-center pb-5 text-white">
                        Vantage Fit's New Launches<sup className="red-font">*</sup>
                    </h2>
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <div className="soln-card soln-card1">
                                <img
                                    className="img-responsive"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1742818618/VantageFit/2025/programs_card.png"
                                    alt="Step challenge"
                                    width="407"
                                    height="554"
                                />
                                <div className="soln-card-content">
                                    <h3>Personalized Programs</h3>
                                    <p>
                                    Personalized Programs are AI powered flexible, self-paced health and wellness solutions designed to meet the unique needs of each employee.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="soln-card soln-card1">
                                <img
                                    className="img-responsive"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1742818618/VantageFit/2025/Wellness_league_card.png"
                                    alt="Wellness Leagues"
                                    width="407"
                                    height="554"
                                />
                                <div className="soln-card-content">
                                    <h3>Wellness Leagues</h3>
                                    <p>
                                    Wellness Leagues categorize employees in 3 tiers based on activity levels, driving customizable goals and continuous improvement.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="soln-card soln-card1">
                                <img
                                    className="img-responsive"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1742818618/VantageFit/2025/Marathon_card.png"
                                    alt="One-day Virtual Marathon"
                                    width="407"
                                    height="554"
                                />
                                <div className="soln-card-content">
                                    <h3>One-day Virtual Marathon</h3>
                                    <p>
                                    One-day Virtual Marathon aims at bringing global teams together while promoting fitness and wellness, regardless of location or time zone.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container custom_container py-5">
                    <h2 className="section-heading text-center text-white pb-5">
                        Our Features
                    </h2>
                    <div className="features-grid">
                        <div className="feature-card holistic-trackers">
                            <h3>Holistic Wellness Trackers</h3>
                            <div className="tracker-list">
                                <div className="tracker-item">
                                    <img className="mr-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/activity_tracking.svg" width="21" height="30" alt="Activity Tracking"/>
                                    Activity Tracking
                                </div>
                                <div className="tracker-item">
                                    <img className="mr-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Health_metrics.svg" width="30" height="30" alt="Health Metrics"/>
                                    Health Metrics
                                </div>
                                <div className="tracker-item">
                                    <img className="mr-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/Nutrition_and_Hydration.svg" width="26" height="30" alt="Nutrition & Hydration"/>
                                    Nutrition & Hydration
                                </div>
                                <div className="tracker-item">
                                    <img className="mr-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/mental_wellbeing.svg" width="40" height="30" alt="Mental Well-being"/>
                                    Mental Well-being
                                </div>
                                <div className="tracker-item">
                                    <img className="mr-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Fitness_and_Exercise.svg" width="22" height="30" alt="Fitness & Exercise"/>
                                    Fitness & Exercise
                                </div>
                            </div>
                        </div>
                        <div className="feature-card">
                            <img className="py-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Admin_Dashboard.svg" width="34" height="66" alt="Admin Dashboard"/>
                            <p>Admin Dashboard</p>
                        </div>
                        <div className="feature-card">
                            <img className="py-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Accessibility.svg" width="31" height="61" alt="Accessibility"/>
                            <p>Accessibility</p>
                        </div>
                        <div className="feature-card">
                            <img className="py-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412164/VantageFit/2023/Integration.svg" width="34" height="66" alt="Integrations"/>
                            <p>Integrations</p>
                        </div>
                        <div className="feature-card">
                            <img className="py-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412164/VantageFit/2023/Incentivization_Rewards.svg" width="35" height="65" alt="Incentivization & Rewards"/>
                            <p>Incentivization & Rewards</p>
                        </div>
                        <div className="feature-card">
                            <img className="py-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Engagement_Tools.svg" width="34" height="66" alt="Engagement Tools"/>
                            <p>Engagement <br/>Tools</p>
                        </div>
                        <div className="feature-card">
                            <img className="py-3" src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/Security_Compliance.svg" width="30" height="66" alt="Security & Compliance"/>
                            <p>Security & <br/>Compliance</p>
                        </div>
                    </div>
                </div>
            </section>
            <section id="casestudy" className="dark-bg1 py-5">
                <div className="container custom_container">
                    <h2 className="section-heading text-center text-white pb-5">
                    Redefining Corporate Wellness in 100+ Organizations
                    </h2>
                    <div className="col-12 d-flex justify-content-center align-items-center pt-2 flex-wrap flex-m-nowrap px-0">
                        <div className="row justify-content-center">
                            <div className="int-logos int-logos-cw mb-3">
                                <div className="sprite3 cwlogo1"></div>
                            </div>
                            <div className="int-logos int-logos-cw mb-3">
                                <div className="sprite3 cwlogo2"></div>
                            </div>
                            <div className="int-logos int-logos-cw mb-3">
                                <div className="sprite3 cwlogo3"></div>
                            </div>
                            <div className="int-logos int-logos-cw mb-3">
                                <div className="sprite3 cwlogo4"></div>
                            </div>
                            <div className="int-logos int-logos-cw mb-3">
                                <div className="sprite3 cwlogo5"></div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="int-logos int-logos-cw mb-3">
                                <div className="sprite3 cwlogo6"></div>
                            </div>
                            <div className="int-logos int-logos-cw mb-3">
                                <div className="sprite3 cwlogo7"></div>
                            </div>
                            <div className="int-logos int-logos-cw mb-3">
                                <div className="sprite3 cwlogo8"></div>
                            </div>
                            <div className="int-logos int-logos-cw mb-3">
                                <div className="sprite3 cwlogo9"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="casestudy" className="py-5">
                <div className="container custom_container">
                    <h2 className="section-heading text-center pb-5">
                        Proven Results Across Industries
                    </h2>
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <div className="prai-container">
                                <div className="sprite3 cwlogo3 prai-img1"></div>
                                <div className="prai-content">
                                    <p>Tata Motors’ wellness initiative saw a significant boost in participation, achieving a <strong>59% engagement rate</strong> and showcasing the effectiveness of structured, goal-driven digital wellness programs.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="prai-container prai-container2">
                                <div className="sprite3 cwlogo9 prai-img2"></div>
                                <div className="prai-content">
                                    <p>Over the course of the 30-days, participants collectively covered more than <strong>4.3 million steps</strong>, illustrating the power of gamified wellness in promoting consistent physical activity.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="prai-container prai-container3">
                                <div className="sprite3 cwlogo1 prai-img3"></div>
                                <div className="prai-content">
                                    <p>Participants in the wellness challenge consistently met their daily walking goals, averaging <strong>over 30,000 steps per week</strong>, leading to a notable increase in daily physical activity.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
              <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block mb-5">
                <div className="col-12">
                  <h2 className="section-heading text-center no-br">
                    Ready to Empower Your Team?
                  </h2>
                  <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                    <a href="#bookDemo" className="vfitcompanycta arrowbtn-img">
                      Book a Demo
                    </a>
                  </div>
                </div>
              </div>
            </section>
        </>
    );
};

export default GEmployeeWellnessPlatform;
